import { render, staticRenderFns } from "./backend-menu.vue?vue&type=template&id=a70218c2&"
import script from "./backend-menu.vue?vue&type=script&lang=js&"
export * from "./backend-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports